var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphonesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.961 11.6506C34.8927 13.3366 35.3587 15.6471 35.3587 18.5821C35.3587 21.4547 34.6831 24.2023 33.3321 26.8251C31.9811 29.3853 30.2341 31.571 28.0913 33.382C23.7122 37.1912 18.7508 39.0959 13.2071 39.0959C7.8497 39.0959 4.05296 37.2537 1.81684 33.5693C0.605615 31.5085 0 29.0732 0 26.2631C0 20.7053 2.11966 15.772 6.35896 11.4632C10.5983 7.15441 15.6528 5 21.5227 5C27.4391 5 31.5851 7.21685 33.961 11.6506Z",
    fill: "#FFC8B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5163 4.87964C15.0252 4.87964 11.3845 8.52034 11.3845 13.0114V26.0221C11.3845 26.9203 10.6564 27.6485 9.75819 27.6485C5.26716 27.6485 1.62646 24.0078 1.62646 19.5168C1.62646 15.549 4.46823 12.2449 8.2275 11.5289C8.95405 5.94187 13.7313 1.62695 19.5163 1.62695C25.3013 1.62695 30.0785 5.94187 30.805 11.5289C34.5643 12.2449 37.4061 15.549 37.4061 19.5168C37.4061 23.4846 34.5643 26.7886 30.805 27.5046C30.0785 33.0916 25.3013 37.4066 19.5163 37.4066C18.6181 37.4066 17.8899 36.6784 17.8899 35.7802C17.8899 34.882 18.6181 34.1539 19.5163 34.1539C24.0073 34.1539 27.648 30.5131 27.648 26.0221V13.0114C27.648 8.52034 24.0073 4.87964 19.5163 4.87964ZM30.9007 24.1182C32.7957 23.4484 34.1534 21.6411 34.1534 19.5168C34.1534 17.3924 32.7957 15.5851 30.9007 14.9153V24.1182ZM8.13185 14.9153C6.23684 15.5851 4.87916 17.3924 4.87916 19.5168C4.87916 21.6411 6.23684 23.4484 8.13185 24.1182V14.9153Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesIcon);
export default __webpack_public_path__ + "static/media/HeadphonesIcon.ca76cc7f96fca4110f25b55bd38165b2.svg";
export { ForwardRef as ReactComponent };